import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icons/info-circle.svg'
import _imports_1 from '@/assets/img/icons/invite-participant.svg'


const _hoisted_1 = { class: "w-1/2 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-center leading-7 font-semibold tracking-wider text-blue-900 mb-4" }, " Konfirmasi Penambahan Peserta ", -1)
const _hoisted_3 = { class: "text-xl text-center leading-7 font-semibold tracking-wider text-black mb-2" }
const _hoisted_4 = { class: "text-base text-center leading-7 tracking-wider text-gray-400 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "bg-blue-100 p-3 flex justify-between items-center rounded-lg mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "text-xs leading-5 text-blue-900" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirm_excluded_participant_modal = _resolveComponent("confirm-excluded-participant-modal")!
  const _component_invitation_summary = _resolveComponent("invitation-summary")!
  const _component_back_button = _resolveComponent("back-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.data?.project?.name), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.state.data?.project?.started_at) + " - " + _toDisplayString(_ctx.state.data?.project?.ended_at), 1),
    (_ctx.state.data.total_excluded && _ctx.state.data.total_excluded > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.state.data.total_excluded) + " dari " + _toDisplayString(_ctx.state.data.total_participants) + " peserta sudah pernah terdaftar", 1),
          _createElementVNode("button", {
            class: "text-blue-900 text-xs font-semibold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowModalParticipant(true)))
          }, " Lihat Detail ")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_confirm_excluded_participant_modal, {
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowModalParticipant(false))),
      show: _ctx.showModalParticipant,
      data: _ctx.state.data.excluded
    }, null, 8, ["show", "data"]),
    _createVNode(_component_invitation_summary, {
      data: _ctx.state.data
    }, null, 8, ["data"]),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payInvitation && _ctx.payInvitation(...args))),
      class: "w-full px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center justify-center gap-3 mb-3"
    }, [
      _hoisted_8,
      _createTextVNode(" Undang Peserta ")
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_back_button)
    ])
  ]))
}